const BASE_URL = '/api/collections/news/entries';
const PAGE_SIZE = 12;

export default () => ({

  page: 1,
  totalPages: null,
  news: [],

  showMore(totalCount) {
    if(this.news.length > 0) {
      return this.page < this.totalPages;
    }
    else {
      if(totalCount > PAGE_SIZE) {
        return true;
      }
    }
    return false
  },

  formatDate(date) {
    let formatedDate = new Date(date);
    return formatedDate.toLocaleDateString(navigator.languages[0], {year: 'numeric', month: 'numeric', day: 'numeric'});
  },

  trimPerex(perex) {
    if (!perex) {
      return;
    }
    if (perex.length > 145) {
      return perex.substring(0, 145) + '...';
    }
    else {
      return perex;
    }
  },

  loadMore() {
    fetch(`${BASE_URL}?limit=${PAGE_SIZE}&sort=-date&page=${this.page + 1}`)
      .then((response) => response.json())
      .then((response) => {
        this.page++;
        this.news.push(...response.data);
        this.totalPages = response.meta.last_page;
      });
  }
});
